import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Mireille Tremblay",
    role: "Propriétaire, Resto Le Plateau",
    initials: "MT",
    quote: "En 90 jours, on a atteint le top 3 Google Maps à Montréal et nos réservations ont explosé de 52 %. L'équipe est attentive, professionnelle et livre ce qu'elle promet.",
    rating: 5,
  },
  {
    name: "Jean-François Côté",
    role: "Directeur, JFC Immobilier",
    initials: "JF",
    quote: "Le chatbot IA qualifie nos prospects 24/7. On est passés de 24 leads par mois à plus de 87 en 4 mois. ROI démentiel sur la publicité Meta.",
    rating: 5,
  },
  {
    name: "Aïsha Diallo",
    role: "Gestionnaire, Clinique Santé+",
    initials: "AD",
    quote: "Les rappels SMS automatiques et le portail patient ont libéré 25 heures par semaine à notre équipe administrative. Le taux de présence est passé à 92 %.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="bg-white py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-12">
          <div className="text-[#00B8D9] text-xs tracking-[0.2em] uppercase font-bold mb-3">Témoignages</div>
          <h2 className="font-heading font-black text-3xl sm:text-4xl lg:text-5xl text-[#0B1F3A] tracking-tight text-balance">
            Ce que disent nos <span className="text-[#00B8D9]">clients</span>
          </h2>
          <p className="mt-4 text-[#4B5563] text-lg">
            Des PME québécoises qui ont transformé leur croissance grâce au numérique.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative bg-[#F5F7FA] rounded-2xl p-7 border border-gray-200 hover:border-[#00B8D9] hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              <Quote className="absolute top-6 right-6 h-10 w-10 text-[#00B8D9]/15" />

              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="h-4 w-4 fill-[#00B8D9] text-[#00B8D9]" />
                ))}
              </div>

              <p className="text-[#0B1F3A] leading-relaxed mb-6 relative z-10">"{t.quote}"</p>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                <div className="h-11 w-11 rounded-full bg-[#0B1F3A] text-white flex items-center justify-center font-heading font-bold text-sm">
                  {t.initials}
                </div>
                <div>
                  <div className="font-heading font-bold text-[#0B1F3A] text-sm">{t.name}</div>
                  <div className="text-xs text-[#4B5563]">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 flex-wrap">
          <div className="flex items-center gap-2">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, i) => <Star key={i} className="h-5 w-5 fill-[#00B8D9] text-[#00B8D9]" />)}
            </div>
            <span className="font-heading font-bold text-[#0B1F3A]">4,9 / 5</span>
            <span className="text-sm text-[#4B5563]">basé sur l'expérience client</span>
          </div>
        </div>
      </div>
    </section>
  );
}
